/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create Campsite Schema
 * @export
 * @interface CreateCampsiteRequest
 */
export interface CreateCampsiteRequest {
    /**
     * Campsite Number
     * @type {string}
     * @memberof CreateCampsiteRequest
     */
    number: string;
    /**
     * Campsite GeoJSON
     * @type {string}
     * @memberof CreateCampsiteRequest
     */
    campsiteGeojson: string;
    /**
     * Campsite Label GeoJSON
     * @type {string}
     * @memberof CreateCampsiteRequest
     */
    campsiteLabelGeojson: string;
}

/**
 * Check if a given object implements the CreateCampsiteRequest interface.
 */
export function instanceOfCreateCampsiteRequest(value: object): value is CreateCampsiteRequest {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('campsiteGeojson' in value) || value['campsiteGeojson'] === undefined) return false;
    if (!('campsiteLabelGeojson' in value) || value['campsiteLabelGeojson'] === undefined) return false;
    return true;
}

export function CreateCampsiteRequestFromJSON(json: any): CreateCampsiteRequest {
    return CreateCampsiteRequestFromJSONTyped(json, false);
}

export function CreateCampsiteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCampsiteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'campsiteGeojson': json['campsite_geojson'],
        'campsiteLabelGeojson': json['campsite_label_geojson'],
    };
}

export function CreateCampsiteRequestToJSON(value?: CreateCampsiteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
        'campsite_geojson': value['campsiteGeojson'],
        'campsite_label_geojson': value['campsiteLabelGeojson'],
    };
}

